/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import { CongratulationsProps } from "./interfaces";
import { congratulationsPageStyle } from "./styles";
import closeLogo from "../../assets/close.svg";
import smileyLogo from "../../assets/smiley-icon.svg";
import { useIsMobile } from "../../hooks/useIsMobile";
import { LinkButton } from "../../atoms/LinkButton";
import { Checkbox } from "@curefit/pandora";
import { CustomButton } from "../../atoms/CustomButton";
import {
  CustomButtonColor,
  CustomButtonTypes,
} from "../../atoms/CustomButton/interface";
import { basicInformationStyle } from "../BasicInformationPage/styles";
import { useHistory } from "react-router-dom";
import { routeURL, UploadTypes } from "../../constants/commons";
import useSTR from "react-str";
import { getData, postData } from "../../utils/fetchers";
import { URL } from "../../API/urlEndpoints";
import { ShowMessage } from "../../components/ShowMessage";
import { showDisplayHeadingAndContentFromLoadingStatus } from "../../utils/helpers";
import { toast } from "react-toastify";
import { useUserContext } from "../../hooks/cookieHooks";
import * as _ from "lodash";
import { ErrorComponent } from "../../molecules/ErrorComponent";
export const Congratulations: React.FunctionComponent<CongratulationsProps> = (
  props
) => {
  const history = useHistory();
  // State to maintain contract
  const [contract, setContract] = React.useState<boolean>(false);

  // [GET] On page load, for fetching the details of Contracts
  const [
    ,
    {
      result: congartualtoryData,
      revalidator: refetchCongartualtoryData,
      loading: loadingCongratulatoryData,
      error: errorCongratulatoryData,
    },
  ] = useSTR(getData);

  // [GET] To fetch the Pre-signed URL to open the Contract/Template in a new tab
  const [
    ,
    {
      result: preSignedAWSURL,
      revalidator: refetchPreSignedAWSURL,
      loading: loadingPreSignedAWSURL,
      error: errorPreSignedAWSURL,
    },
  ] = useSTR(getData);

  // [POST] On page load, for sending the details of Contracts
  const [
    ,
    {
      result: postContractData,
      revalidator: refetchContractData,
      loading: loadingContractData,
      error: errorContractData,
    },
  ] = useSTR(postData);
  // Calling the SSO Hook to retrieve user information of the logged in user
  const user = useUserContext();

  const isMobileView = useIsMobile();
  // Function called when user toggles the contract Checkbox
  const onAcceptContract = (checked: boolean) => {
    setContract(checked);
  };
  // Function called when the I ACCEPT button is clicked
  const onTermsAndConditionsAccept = () => {
    refetchContractData(
      `${URL.postCongratulatorydetails(_.get(user, "empId"))}`,
      {}
    );
  };

  // [GET] On Page load
  React.useEffect(() => {
    refetchCongartualtoryData(
      `${URL.getCongratulatoryDetails(_.get(user, "empId"), true)}`
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Function which is called when the cross button is clicked
  const onClickOfExitButton = () => {
    history.push(routeURL.dashboard);
  };

  // Function which is executed when the POST call is successfull
  React.useEffect(() => {
    if (postContractData && postContractData?.success) {
      toast.success(postContractData?.message);
      history.push(routeURL.welcomeAboardScreen);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postContractData]);

  React.useEffect(() => {
    if (congartualtoryData && congartualtoryData?.isAccepted) {
      history.push(routeURL.welcomeAboardScreen);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [congartualtoryData]);

  // Variable which shows the loading state
  const isScreenLoading = React.useMemo(() => {
    return (
      loadingCongratulatoryData || loadingContractData || loadingPreSignedAWSURL
    );
  }, [loadingCongratulatoryData, loadingContractData, loadingPreSignedAWSURL]);

  // Hook which is called whenever there is an error in either GET/POST calls
  const showErrorComponent = React.useMemo(() => {
    return errorContractData || errorCongratulatoryData || errorPreSignedAWSURL;
  }, [errorCongratulatoryData, errorContractData, errorPreSignedAWSURL]);

  // Function which is called when the user clicks on the DOWNLOAD button
  const onDownloadClick = () => {
    refetchPreSignedAWSURL(
      `${URL.downloadTemplatesContracts(
        _.get(user, "empId"),
        UploadTypes.CONTRACT_DOCUMENT
      )}`
    );
  };

  // Hook which is executed when the pre-signed URL is got from the API call
  React.useEffect(() => {
    if (preSignedAWSURL) {
      window.open(preSignedAWSURL, "_blank");
    }
  }, [preSignedAWSURL]);

  return (
    <span css={[basicInformationStyle, congratulationsPageStyle]}>
      <ShowMessage
        visible={isScreenLoading}
        loading={isScreenLoading}
        heading={
          showDisplayHeadingAndContentFromLoadingStatus({
            preLoginScreen: loadingCongratulatoryData,
            postLoginScreen: loadingContractData,
          })?.loadingHeading
        }
        description={
          showDisplayHeadingAndContentFromLoadingStatus({
            preLoginScreen: loadingCongratulatoryData,
            postLoginScreen: loadingContractData,
          })?.loadingDescription
        }
      />
      <div className="container pt-4 document-container">
        <div className="d-flex align-items-center justify-content-center ">
          <div className="mr-auto"></div>
          <button
            className="close-mark-container bg-none border-0 user-button-style"
            onClick={onClickOfExitButton}
          >
            <img src={closeLogo} alt="Close Icon" />
          </button>
        </div>
        <div className="congratulations-screen-responsive-container">
          <div className="row">
            <div className="col">
              <div className="d-flex">
                <div
                  className={`smiley-image-container d-flex align-items-center justify-content-center ${
                    isMobileView ? "mr-3" : "mr-5"
                  }`}
                >
                  <img src={smileyLogo} alt="" width="100%" height="100%" />
                </div>
                <div>
                  <h3>Congratulations!</h3>
                  <div>
                    Registration process is complete. Please accept the T&C to
                    proceed further.
                  </div>
                </div>
              </div>
              <div className="d-flex mt-3">
                <div className="mr-auto my-3 heading-style">
                  Contract Details
                </div>
                <LinkButton
                  className="my-3 terms-style"
                  onClick={onDownloadClick}
                >
                  DOWNLOAD
                </LinkButton>
              </div>
              <div className="contract-background">
                <div
                  dangerouslySetInnerHTML={{
                    __html: congartualtoryData && congartualtoryData.data,
                  }}
                />
              </div>
            </div>
          </div>
          <div className="my-3">
            <Checkbox
              label="I’ve read the contract and I accept all terms and conditions"
              onChange={onAcceptContract}
              checked={contract}
            />
          </div>
          <div className="mt-3 mb-4">
            <div className="horizontal-line-style"></div>
          </div>
          {showErrorComponent && (
            <ErrorComponent errorObj={showErrorComponent} />
          )}
          <div className="my-3 row no-gutters">
            <div className="col-3 d-none d-md-block"></div>
            <div className="col-md-6 col-12">
              <CustomButton
                className="accept-button-style button-style-red user-button-style"
                color={CustomButtonColor.PRIMARY}
                type={CustomButtonTypes.BUTTON}
                onClick={onTermsAndConditionsAccept}
                disabled={!contract}
              >
                ACCEPT and CONTINUE
              </CustomButton>
            </div>
            <div className="col-3 d-none d-md-block"></div>
          </div>
        </div>
      </div>
    </span>
  );
};
